// extracted by mini-css-extract-plugin
export default {"section_result":"ResultPage_section_result__OphUZ","resultCard":"ResultPage_resultCard__yDUQN","icon":"ResultPage_icon__MT5y8"};